import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@veracity/vui'
import { useNavigate } from 'react-router-dom'

import { incomeAdjustmentClient, wholesaleMarketClient } from '@/api'

const BASE_ROUTE = '/library/income-adjustments'
const BASE_QUERY_KEY = wholesaleMarketClient.QUERY_KEY
export const useIncomeAdjustments = () => {
  const { showSuccess } = useToast()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const incomeAdjustmentQuery = useQuery({
    queryKey: [...BASE_QUERY_KEY, { lockedOnly: false }],
    queryFn: () => incomeAdjustmentClient.getAll()
  })

  const addDatasetMutation = useMutation({
    mutationFn: incomeAdjustmentClient.addDataset,
    onSuccess: (datasetId: number) => {
      showSuccess('Dataset successfully added')
      navigate(`${BASE_ROUTE}/${datasetId}`)
    }
  })

  const cloneDatasetMutation = useMutation({
    mutationFn: incomeAdjustmentClient.cloneDataset,
    onSuccess: (datasetId: number) => {
      showSuccess('Dataset successfully cloned')
      navigate(`${BASE_ROUTE}/${datasetId}`)
    }
  })

  const removeDatasetMutation = useMutation({
    mutationFn: incomeAdjustmentClient.removeDataset,
    onSuccess: async () => {
      showSuccess('Dataset successfully removed')
      await queryClient.invalidateQueries({ queryKey: BASE_QUERY_KEY })
    }
  })

  return {
    incomeAdjustmentDatasets: incomeAdjustmentQuery.data || [],
    isFetching:
      incomeAdjustmentQuery.isFetching && !incomeAdjustmentQuery.isRefetching,
    addDataset: addDatasetMutation.mutate,
    isAddDatasetInProgress: addDatasetMutation.isPending,
    cloneDataset: cloneDatasetMutation.mutate,
    isCloneDatasetInProgress: cloneDatasetMutation.isPending,
    removeDataset: removeDatasetMutation.mutate
  }
}
